accountsAndBudgets.classy.controller({
    name: 'AccountsAndBudgetsController',
    inject: ['$scope', 'AccountModelService', '$rootScope', 'standardCudArrayFactory', 'SchoolModelService',
        'HelpSystemModelService', '$q', 'authServiceFactory'],
    init: function()
    {
        this.$rootScope.model = this.AccountModelService;
        this.$.AccountModelService = this.AccountModelService;
        this.$.arrayCud = new this.standardCudArrayFactory(this.AccountModelService,
            this.authServiceFactory.getAuth().schoolID, this.AccountModelService.get(), this, ['items']);
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.items = this.AccountModelService.get();
        this.$.projection();
    },
    add: function()
    {
        this.$.arrayCud.editItem[this.$.items.accounts.length] = true;
        this.AccountModelService.new();
        this.$.items = this.AccountModelService.data;
    },
    projection: function()
    {
        var proj = 0;
        for (var i=0; i<this.$.items.accounts.length; i++){
            if (this.$.items.accounts[i].deleted==0)  
                proj += Number(this.$.items.accounts[i].Budget);
        }
        this.$.projBudget=proj;
    },
    activeChange: function(item, field)
    {
        item[field] = Number(item[field]);
    },
    del: function(index)
    {
        if (typeof this.$.items.accounts[index].recordID !== 'undefined')
        {
            this.$.items.accounts[index].showDeleted = 1;
            this.$.items.accounts[index].deleted = 1;
            this.$.arrayCud.toggleEditItem(index);
            this.$.projection();
        }
        else
        {
            this.$.arrayCud.editItem.pop();
            this.$.items.accounts.pop();
            this.$.projection();
        }
    },
    startSaveProcess: function(scope, instance, form)
    {
        instance.options.factor  = .3;
        var deferred = this.$q.defer();
        var id = this.authServiceFactory.getAuth().schoolID;
        var self = this;
        this.$q.all([
                this.AccountModelService.putMultiple(id, this.$.items),
                this.SchoolModelService.put(id, {'recordID': this.authServiceFactory.getAuth().schoolID, 'Total_Award_Budget': this.$.items.Total_Award_Budget}, instance),
            ]).then(function (results) {
                self.$.arrayCud.editItem = [];
                self.$.arrayCud.model.set(results[0].data);
                self.$.items = self.$.arrayCud.model.get();
                self.$.arrayCud.updateCopy();
                deferred.resolve(results);
        });
        this.$.projection();
        return deferred.promise;
    }
});